const WaveDivider = ({ flip = false, color = "#00FF66", opacity = 0.35 }) => {
  return (
    <div
      className="w-full overflow-hidden leading-none"
      style={{ transform: flip ? "rotate(180deg)" : "none" }}
      data-testid="wave-divider"
    >
      <svg
        viewBox="0 0 1200 80"
        preserveAspectRatio="none"
        className="w-full h-[60px]"
      >
        <path
          d="M0,40 C200,10 400,70 600,40 C800,10 1000,70 1200,40 L1200,80 L0,80 Z"
          fill={color}
          fillOpacity={opacity}
        />
        <path
          d="M0,50 C250,20 450,80 700,50 C900,20 1050,80 1200,50 L1200,80 L0,80 Z"
          fill={color}
          fillOpacity={opacity * 0.5}
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
